import React from 'react'
import Button from '../common/button'
import Input from '../common/input'
import { createTable } from '../../routes'
import Paths, { openRoute } from '../../router'
import PublicTables from './publicTables'
import { fromJS, is } from 'immutable'
import { timeLimitToString } from '../../util'
import Checkbox from '../common/checkbox'

class Welcome extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            timeLimit: fromJS({ base: -1, increase: 0 }),
            tableSettings: fromJS({ withPigletEvolutions: true }),
            isPublic: true,
            tableCode: "",
            isLoading: false
        }
    }

    handleCreate()
    {
        this.setState({ isLoading: true }, () => {
            createTable(
                {
                    isPublic: this.state.isPublic,
                    timeLimit: this.state.timeLimit ? this.state.timeLimit.toJS() : null,
                    tableSettings: this.state.tableSettings.toJS()
                },
                resp => {
                    const code = resp.code
                    openRoute(this.props.history, Paths.Table.JOIN, code)
                },
                err => {
                    getDialog().text(Messages("welcome.create-table.error"))
                    console.error(err)
                    this.setState({ isLoading: false })
                }
            )
        })
    }

    handleJoinTable()
    {
        openRoute(this.props.history, Paths.Table.JOIN, this.state.tableCode)
    }

    renderTimeLimitSelection()
    {
        const timeLimits = fromJS([
            { base: -1, increase: 0 },
            { base: 90000, increase: 2000 },
            { base: 60000, increase: 0 },
            { base: 30000, increase: 3000 },
            { base: 30000, increase: 0 },
            { base: 10000, increase: 1000 },
            { base: 10000, increase: 0 },
        ]).map(tl => {
            const isSelected = is(this.state.timeLimit, tl)
            return (
                <div 
                    onClick={ () => this.setState({ timeLimit: tl }) }
                    key={ JSON.stringify(tl.toJS()) } 
                    className={"dk-button time-limit " + (isSelected ? " selected " : "")}>
                    { timeLimitToString(tl) }
                </div>
            )
        })

        return (
            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 10,
                flexWrap: "wrap",
            }}>
                { timeLimits }
            </div>  
        )
    }

    render()
    {
        return (
            <div className="welcome">
                <div className="heading">
                    <img className="icon" src="/assets/images/icon_doko.png" />
                    <div>{ Messages("app.title") }</div>
                </div>
                <div className="dk-separator" />
                <div className="welcome-container">
                    <div className="welcome-create">
                        <div>{ Messages("welcome.create-table.description") }</div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: 10 }}>
                            <div style={{
                                marginTop: 10,
                                opacity: .8,
                                fontSize: 14
                            }}>{ Messages("table.time-limit") }</div>
                            { this.renderTimeLimitSelection() }
                            <Checkbox
                                style={{ margin: "20px 0px 10px 0px" }}
                                checked={ this.state.tableSettings.get("withPigletEvolutions") }
                                onChange={ v => this.setState({ tableSettings: this.state.tableSettings.set("withPigletEvolutions", v) }) }
                                text={ Messages("table.table-settings.with-piglet-evolutions") }
                            />
                            <Checkbox
                                style={{ margin: "10px 0px 20px 0px" }}
                                checked={ this.state.isPublic }
                                onChange={ () => this.setState({ isPublic: !this.state.isPublic }) }
                                text={ Messages("table.public-table.description") }
                            />
                            <Button
                                text={ Messages("welcome.create-table.action") }
                                disabled={ this.state.isLoading }
                                onClick={ this.handleCreate.bind(this) }
                            />
                        </div>
                    </div>
                    <div className="separator" />
                    <div className="welcome-join">
                        <div>{ Messages("welcome.join-table.description") }</div>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            marginTop: 10
                        }}>
                            <Input
                                placeholder={ Messages("welcome.join-table.code") }
                                onChange={ v => this.setState({ tableCode: v.toUpperCase() }) }
                                value={ this.state.tableCode }
                                style={{ marginRight: 10 }}
                            />
                            <Button
                                text={ Messages("welcome.join-table.action") }
                                disabled={ !this.state.tableCode || this.state.isLoading }
                                onClick={ this.handleJoinTable.bind(this) }
                            />
                        </div>
                        <div className="dk-separator" />
                        <div>{ Messages("welcome.public-tables") }</div>
                        <PublicTables />
                    </div>
                </div>
            </div>
        )
    }

}

export { Welcome }
export default Welcome